import { useEffect, useRef } from "react";

export default function ModalProgress({
    open,
    percent = 0,
    speedMBps = 0,
    etaSec = 0,
    onCancel,
    title = "업로드 중…",
    subtitle = "잠시만 기다려 주세요.",
}) {
    const dialogRef = useRef(null);

    // 모달 열릴 때 백그라운드 스크롤 잠금 + ESC로 취소
    useEffect(() => {
        if (!open) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        const onKey = (e) => {
            if (e.key === "Escape" && onCancel) onCancel();
        };
        document.addEventListener("keydown", onKey);
        return () => {
            document.body.style.overflow = prev;
            document.removeEventListener("keydown", onKey);
        };
    }, [open, onCancel]);

    const fmtEta = (s) => {
        if (!s || !isFinite(s)) return "—";
        if (s < 60) return `${Math.round(s)}초`;
        const m = Math.floor(s / 60);
        const ss = Math.round(s % 60);
        return `${m}분 ${ss}초`;
    };

    if (!open) return null;

    return (
        <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="upload-title"
            className="modal-overlay"
            ref={dialogRef}
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(15, 23, 42, 0.45)",
                display: "grid",
                placeItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                className="modal-card"
                style={{
                    width: "min(520px, 92vw)",
                    background: "#fff",
                    borderRadius: 16,
                    boxShadow: "0 24px 60px rgba(0,0,0,.25)",
                    padding: 20,
                }}
            >
                <div style={{ display: "grid", gap: 10 }}>
                    <div id="upload-title" style={{ fontSize: 18, fontWeight: 700, color: "#0f172a" }}>
                        {title}
                    </div>
                    <div style={{ color: "#475569", fontSize: 13 }}>{subtitle}</div>

                    {/* 진행률 바 */}
                    <div style={{ marginTop: 6 }}>
                        <div
                            aria-label="progress"
                            role="progressbar"
                            aria-valuemin={0}
                            aria-valuemax={100}
                            aria-valuenow={percent}
                            style={{
                                height: 10,
                                background: "#e2e8f0",
                                borderRadius: 999,
                                overflow: "hidden",
                            }}
                        >
                            <div
                                style={{
                                    width: `${Math.min(100, Math.max(0, percent))}%`,
                                    height: "100%",
                                    background: "#2563eb",
                                    transition: "width .2s ease",
                                }}
                            />
                        </div>
                        <div
                            style={{
                                marginTop: 8,
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize: 12,
                                color: "#334155",
                            }}
                        >
                            <span>{percent}%</span>
                            <span>
                                {speedMBps.toFixed(2)} MB/s · 남은 시간 {fmtEta(etaSec)}
                            </span>
                        </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 8 }}>
                        <button
                            type="button"
                            onClick={onCancel}
                            className="btn btn--ghost"
                            style={{
                                padding: "8px 12px",
                                borderRadius: 10,
                                background: "#f1f5f9",
                                border: "1px solid #e2e8f0",
                            }}
                        >
                            업로드 취소 (ESC)
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
